<!-- controls：向用户显示播放按钮控件 -->
<template>
  <video
    ref="video"
    class="video-js vjs-default-skin video-class"
    controls
    :poster="img"
  >
    <source :src="src" />
  </video>
</template>
<script>
export default {
  props: {
    src: {
      type: String,
      default: () =>'',
    },
    img: {
      type: String,
      default: () =>'',
    },
  },
  data() {
    return {
      player: null, // 用来存储当前 video
    };
  },
  mounted() { // 渲染视频
    this.player = this.$video(this.$refs.video);
  },
  methods: {

  },
};
</script>
<style scoped>
  .video-class {
    width: calc(100%);
    height: calc(100%);
  }

  .video-js .vjs-time-control {
    display: block !important;
  }
  .video-js .vjs-remaining-time {
    display: none !important;
  }
</style>